import {
  KalturaPin,
  KalturaPinType,
  PinUpdateAction,
  PinValidateAction,
  KalturaEntityReferenceBy,
} from '@kaltura-ott/ott-client-types/api/types';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { kalturaClient } from './kaltura-clent';

/**
 * Build request payload for service 'Pin' action 'Validate'.
 *
 * Usage: Purchase subscription PinValidateAction
 *
 * @param pin number
 * @param type
 * @category Purchase / Subscriptions
 * @function
 */
export const pinValidate = (pin: string, type: KalturaPinType) => {
  const client = kalturaClient();
  const action = new PinValidateAction({
    pin,
    type,
  });

  return client.request(action).pipe(
    catchError((error) =>
      throwError({
        error: error.code,
        message: error.message,
      }),
    ),
  );
};

/**
 * Build request payload for service 'Pin' action 'Validate'.
 *
 * Usage: Purchase / Parental subscription PinUpdateAction
 *
 * @param pin number
 * @param type
 * @param by
 * @category Purchase / Subscriptions
 * @function
 */
export const pinUpdate = (pin: KalturaPin, type: KalturaPinType, by: KalturaEntityReferenceBy) => {
  const client = kalturaClient();
  const action = new PinUpdateAction({
    by,
    pin,
    type,
  });

  return client.request(action).pipe(
    catchError((error) => {
      console.warn('Pin Update error', error);
      return throwError(error);
    }),
  );
};

/**
 * Build request payload for service 'Pin' action 'Validate', type purchase.
 *
 * Usage: Purchase subscription PinValidateAction
 *
 * @param pin number
 * @category Purchase / Subscriptions
 * @function
 */
export const pinValidatePurchase = (pin: string) => {
  return pinValidate(pin, KalturaPinType.purchase);
};

/**
 * Build request payload for service 'Pin' action 'Validate', type parental.
 *
 * Usage: Purchase subscription PinValidateAction
 *
 * @param pin number
 * @category Purchase / Subscriptions
 * @function
 */
export const pinValidateParental = (pin: string) => {
  return pinValidate(pin, KalturaPinType.parental);
};

/**
 * Build request payload for service 'Pin' action 'Validate', type purchase.
 *
 * Usage: Purchase subscription PinUpdateAction
 *
 * @param pin number
 * @category Purchase / Subscriptions
 * @function
 */
export const pinUpdatePurchase = (pin: string) => {
  const newPin = new KalturaPin({
    pin,
    type: KalturaPinType.purchase,
  });
  return pinUpdate(newPin, KalturaPinType.purchase, KalturaEntityReferenceBy.household);
};

/**
 * Build request payload for service 'Pin' action 'Validate', type parental.
 *
 * Usage: Parental PinUpdateAction
 *
 * @param pin number
 * @category Parental
 * @function
 */
export const pinUpdateParental = (pin: string) => {
  const newPin = new KalturaPin({
    pin,
    type: KalturaPinType.parental,
  });
  return pinUpdate(newPin, KalturaPinType.parental, KalturaEntityReferenceBy.household);
};
